import React from "react";
import { Box, Tab, Tabs } from "@mui/material";
import { CorporateEventDetailsTabs, ICorporateEvent } from "../../../../interfaces/corporateEvent";
import EventTabContent from "./event-tab-content/EventTabContent";
import QuotesTabContent from "./QuotesTabContent";
import palette from "../../../../theme/palette";
import { CorporateEventTabsEnum } from "../../../../constants/enums";
import { getDeclineReason } from "../../../../utils/B2B/corporateEventsUtils";
import DeclineReasonBanner from "./decline-reason-banner/DeclineReasonBanner";
import "./EventDetailsSection.scss";

interface EventDetailsSectionProps {
	selectedTab: CorporateEventTabsEnum;
	corporateEventDetail: ICorporateEvent;
	isEventDeclined: boolean;
	OnClickTriggerLeftContainerScroll?: () => void;
	setSelectedTab: (tab: CorporateEventTabsEnum) => void;
	onClickAddAdditionalQuote?: () => void;
}

const EventDetailsSection: React.FC<EventDetailsSectionProps> = ({
	selectedTab,
	corporateEventDetail,
	setSelectedTab,
	onClickAddAdditionalQuote,
	OnClickTriggerLeftContainerScroll,
	isEventDeclined
}) => {
	const declineReason = getDeclineReason(corporateEventDetail);

	const handleTabChange = (newValue: CorporateEventTabsEnum) => {
		setSelectedTab(newValue);
	};

	return (
		<Box className="eventDetailsSection">
			{/* Main Tabs: Event & Quotes */}
			<Box className="mainTabsContainer">
				<Tabs
					value={selectedTab}
					onChange={(_, newValue) => {
						handleTabChange(newValue);
						OnClickTriggerLeftContainerScroll?.();
					}}
					className="mainTabs"
					classes={{
						list: "tabsFlexContainer",
					}}
					slotProps={{
						indicator: {
							style: { backgroundColor: palette.primary.main, height: "2px" },
						}
					}}
				>
					<Tab
						label="Event"
						value={CorporateEventTabsEnum.Event}
						className={`mainTab ${selectedTab === CorporateEventTabsEnum.Event ? "active" : ""}`}
					/>
					<Tab
						label="Quotes"
						value={CorporateEventTabsEnum.Quotes}
						className={`mainTab ${selectedTab === CorporateEventTabsEnum.Quotes ? "active" : ""}`}
					/>
				</Tabs>
			</Box>

			{isEventDeclined && <DeclineReasonBanner declineReason={declineReason || ""} />}

			{/* Tab Content */}
			<Box className="tabContent">
				{selectedTab === CorporateEventTabsEnum.Event && (
					<EventTabContent
						corporateEventDetail={corporateEventDetail}
						OnClickTriggerLeftContainerScroll={OnClickTriggerLeftContainerScroll}
					/>
				)}
				{selectedTab === CorporateEventTabsEnum.Quotes && (
					<QuotesTabContent
						corporateEventDetail={corporateEventDetail}
						onClickAddAdditionalQuote={onClickAddAdditionalQuote}
						isEventDeclined={isEventDeclined}
					/>
				)}
			</Box>
		</Box>
	);
};

export default EventDetailsSection;
